@if (form) {
    <form [formGroup]="form" class="d-flex flex-column psic-gap-4">
        @for (field of fields; track field) {
            <div>
                @if (field.type === 'text') {
                    <lib-input-text [field]="field" [formControlName]="field.name"> </lib-input-text>
                } @if (field.type === 'dropdown') {
                    <lib-dropdown [field]="field" [formControlName]="field.name"> </lib-dropdown>
                } @if (field.type === 'textarea') {
                    <mat-form-field class="dynamic-textarea-field w-100" appearance="fill" floatLabel="always"
                        subscriptSizing="dynamic" hideRequiredMarker>
                        <mat-label>{{ field.caption }}</mat-label>
                        <textarea matInput class="caption" style="resize: none; min-height: 80px" rows="4" [id]="field.id"
                            [placeholder]="field.placeholder" [maxlength]="field.maxLength" [readonly]="field.readonly"
                            [formControlName]="field.name"></textarea>
                        <mat-hint align="start" class="disclaimer psic-mt-1">
                            {{ getRemainingCharacters(field) }} of {{ field.maxLength }} characters left
                        </mat-hint>
                    </mat-form-field>
                }
            </div>
        }
    </form>
}